import { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';

import { useAppDispatch } from '@/hooks/useReduxHooks';

function LoginAuto() {
  const history = useHistory();
  const loginToken = localStorage.getItem('login');
  const departureDateToken = localStorage.getItem('departureDate');
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (history.location.pathname.includes('/inquiry')) {
      return;
    }

    if (isMobile) {
      if (loginToken) {
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            passportNumber: loginToken,
            departureDate: departureDateToken,
          },
        });
      } else {
        history.push(
          history.location.pathname.match('medical') ? '/medical' : '/',
        );
      }
    }
  }, []);

  return <></>;
}

export default LoginAuto;
